import { Breadcrumb } from "@refinedev/mui";
import { Box } from "@mui/material";
import PageHeading from "../../components/pageHeading";
export const CYRCSTEMComputersChildrenGraduatedGradeFiveToCYRC = () => {
  return (
    <Box>
      <Breadcrumb />
      <PageHeading heading="Children graduated grade 5 to CYRC" />
    </Box>
  );
};
